import debounce from '../../assets/scripts/utils/debounce';
document.querySelectorAll('.nav').forEach((element) => {
    const toggles = document.querySelectorAll('[data-toggle="nav"]');
    const page = document.querySelector('.page');
    const init = () => {
        if (!matchMedia('(min-width: 80em)').matches) {
            element.style.visibility = 'hidden';
            element.setAttribute('aria-hidden', 'true');
        }
        element.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => {
                if (!matchMedia('(min-width: 80em)').matches && isOpen()) {
                    close();
                }
            });
        });
    };
    init();
    const reset = () => {
        var _a;
        element.removeAttribute('aria-hidden');
        element.removeAttribute('aria-modal');
        element.removeAttribute('role');
        element.style.visibility = '';
        (_a = window.scrollLock) === null || _a === void 0 ? void 0 : _a.enableScrolling();
    };
    const open = () => {
        var _a;
        element.classList.add('is-open');
        element.setAttribute('aria-hidden', 'false');
        element.setAttribute('aria-modal', 'true');
        element.setAttribute('role', 'dialog');
        element.style.visibility = 'visible';
        toggles.forEach((toggle) => {
            toggle.classList.add('active');
        });
        if (page)
            page.classList.add('is-nav-open');
        (_a = window.scrollLock) === null || _a === void 0 ? void 0 : _a.disableScrolling();
        element.dispatchEvent(new CustomEvent('open'));
    };
    const close = () => {
        var _a;
        element.classList.remove('is-open');
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('aria-modal', 'false');
        element.setAttribute('role', 'none');
        setTimeout(() => {
            element.style.visibility = 'hidden';
        }, 300);
        toggles.forEach((toggle) => {
            toggle.classList.remove('active');
        });
        if (page)
            page.classList.remove('is-nav-open');
        (_a = window.scrollLock) === null || _a === void 0 ? void 0 : _a.enableScrolling();
        element.dispatchEvent(new CustomEvent('close'));
    };
    const isOpen = () => element.classList.contains('is-open');
    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            if (isOpen()) {
                close();
            }
            else {
                open();
            }
        }, true);
    });
    document.addEventListener('keydown', (event) => {
        if ((event.code === 'Escape') && isOpen()) {
            close();
        }
    }, false);
    /*
      Принудительно закрываем и сбрасываем навигационную панель
      при расширении браузера за пределы мобильных разрешений
    */
    const handleResizePage = () => {
        if (matchMedia('(min-width: 80em)').matches) {
            if (isOpen())
                close();
            setTimeout(reset, 310);
        }
    };
    window.addEventListener('resize', debounce(handleResizePage, 200));
});
